module.exports = __webpack_public_path__ + "static/Centralised_repository-dddfe139ca27bb4d20388ef254db42d5.svg";